/**
 * Localization messages for DashboardFilterPills component
 */
import sharedMessages from '../../../shared/messages/sharedMessages';
import { mergeInvertedMessages } from '../../../utils/localization';

const componentMessages = {
  // add component strings here as needed
} as const;

const invertedMessages = mergeInvertedMessages(
  sharedMessages,
  componentMessages
);

export type DashboardFilterPillsMessage = keyof typeof invertedMessages;

export default invertedMessages;
